export enum SERVICE_TYPES {
  wms = 'wms',
  wmts = 'wmts',
  map_image = 'map-image',
  feature = 'feature',
  kml = 'kml',
  featureLayer = 'featureLayer',
  vector_tile = 'vector-tile',
  custom_search_Layer = 'custom-search-layer'
}

export enum SERVICE_CONTROL_NAME {
  serviceTitleInput = 'serviceTitleInput',
  serviceTypeSelect = 'serviceTypeSelect',
  serviceUrlInput = 'serviceUrlInput',
  subLayersTypeahead = 'subLayersTypeahead',
}
